<template>
    <transition name="fade" @after-enter="afterOpen" @after-leave="afterClose">
        <div class="modal" v-on:keyup.esc="close" tabindex="0" @mousedown.self="close" v-if="show">
            <transition :name="transition" @before-enter="beforeOpen">
                <div :style="[ modalWidth ? { width: modalWidth, maxWidth: '100%' } : '', modalHeight ? { height: modalHeight, maxHeight: '100%'} : '']" class="modal-wrap" v-show="showWrap">
                    <div class="header" v-if="$slots.header">
                        <h3 class="title"><slot name="header"></slot></h3>
                        <i class="icon close" @click="close"></i>
                    </div>

                    <div class="custom-header" v-if="$slots['custom-header']">
                        <slot name="custom-header"></slot>
                        <i class="icon close" @click="close"></i>
                    </div>

                    <div class="body" v-if="$slots.body">
                        <div class="body-wrap">
                            <slot name="body"></slot>
                        </div>
                    </div>

                    <div class="footer" v-if="$slots.footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
    export default {
		name: 'Modal',

		props: {
            initialShow: { type: Boolean, default: false },
            initialShowParam: { type: String, default: '' },
            modalWidth: { type: String, default: '' },
            modalHeight: { type: String, default: '' },
            transition: { type: String, default: 'leave-bottom' }
		},

        data() {
            return {
				show: false,
				showWrap: false,
            };
		},

		mounted() {
            this.show = this.initialShowParam ? this.openIfParamIsSet(this.initialShowParam) : this.initialShow;
		},

        updated() {
            this.showWrap = this.show;
        },

		methods: {
			close() {
				this.$emit('close')
				this.show = false;
				this.showWrap = false;
            },

            beforeOpen() {
				this.$emit('before-open');
			},

			afterOpen() {
                if (this.show) {
                    this.$emit('after-open');
                    this.$el.focus();
                }
            },

            afterClose() {
				if (!this.show) this.$emit('after-close');
            },

            openIfParamIsSet(param) {
                return window.location.search ? window.location.search.includes(param) : false;
            }
		}
    };
</script>
